export interface IconProps {
  width?: number;
  height?: number;
}

export default function AlignMiddleIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
    >
      <g transform="translate(-.081 .001)">
        <path
          fill="currentColor"
          d="M.489 14a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm2-4.064a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm-2-4.064a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.751a.5.5 0 01-.5.5zm2-4.122a.5.5 0 01-.5-.5V.5a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5z"
          data-name="Union 25"
          transform="translate(.092 -.001)"
        ></path>
      </g>
    </svg>
  );
}
